<!-- src/components/Layout.vue -->
<template>
	<div>

		<el-header style="background-color: #545c64; display: flex; align-items: center; padding: 0 40px;">
			<!-- 左侧图标 -->
			<img src="../../src/assets/app_logo.jpg" alt="Logo" style="height: 40px; margin-right: 20px;">

			<!-- 标题文字 -->
			<h1 style="color: #ffffff; font-family: 'Arial', sans-serif; font-size: 24px; margin: 0 auto;">QIUI 后台管理系统
			</h1>
		</el-header>


		<el-container style="background-color:#545c64;">
			<!-- 下面 -->
			<el-aside width="144px">
				<!-- 下面的左边 -->
				<el-menu default-active="/WindControlHome" @select="handleSelect" class="el-menu-vertical-demo"
					background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">

					<el-menu-item index="/WindControlHome">
						<i class="el-icon-s-custom"></i>
						<span slot="title">风控管理</span>
					</el-menu-item>

					<el-menu-item index="/WarehouseHome">
						<i class="el-icon-document"></i>
						<span slot="title">入库管理</span>
					</el-menu-item>

					<el-menu-item index="/AfterSalesHome">
						<i class="el-icon-setting"></i>
						<span slot="title">售后管理</span>
					</el-menu-item>

					<el-submenu index="1">
						<template slot="title">
							<i class="el-icon-bank-card"></i>
							<span>直播管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/RealNameHome">实名认证</el-menu-item>
							<el-menu-item index="/BankCardHome">银行卡认证</el-menu-item>
							<el-menu-item index="/WithdrawalHome">提现申请</el-menu-item>
							<el-menu-item index="/VoiceRoomManagement">语音房管理</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-menu-item index="/SingleSummary">
						<i class="el-icon-position"></i>
						<span slot="title">其他</span>
					</el-menu-item>




				</el-menu>

			</el-aside>

			<el-main style="background-color: #ffffff; overflow: auto;">
				<!-- 下面的右边 -->
				<router-view></router-view>
			</el-main>


		</el-container>


	</div>
</template>

<script>
	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {

			//默认打开的路由
			if (this.$route.path !== '/WindControlHome') {
				this.$router.push({
					path: '/WindControlHome',
					query: {}
				});
			}
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				isfirst: 0, //是否是第一次加载
				password: '',
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				if (this.$route.path !== key) { //同一个地址 不重复导航
					this.$router.push(key);
				}
			}
		}
	};
</script>

<style>
	h1 {
		margin: 0;
		color: #ddd;
	}
</style>